<template>
	<div>
		<el-container>
			
			<el-main>
				<el-form :model="editForm" :rules="editFormRules" ref="editForm" class="demo-form-inline" :inline="true" >

					<el-form-item label="指纹编号">
						<el-select v-model="editForm.fingerNum" 
						placeholder="请选择" 
						style="display: block; width: 130px;"
						@change="handleSelectChange">
							<el-option
							v-for="item in fingerNoOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>	

					<el-form-item label="说明">
						<el-input v-model="editForm.remark" autocomplete="off"></el-input>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" :disabled="isCollect" @click="startCollectFinger()">开始采集</el-button>
						<el-button type="warning" :disabled="!isCollect" @click="stopCollectFinger()">停止采集</el-button>
						<el-button type="primary" @click="submitForm('editForm')">保存指纹</el-button>
					</el-form-item>
					<el-form-item> 
						<span style="color: red !important;font-size:15px;">{{ collectTitle }}</span>
					</el-form-item>
				</el-form>

				<el-table
						ref="fingerTable"
						:data="fingerData"
						tooltip-effect="dark"
						style="width: 100%; margin-top: 0px;"
						height="200px"
						:row-style="{height: '0px'}"
						:cell-style="{padding: '2px'}"
						:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						border
						stripe
						@selection-change="handleSelectionChange">

					<!-- <el-table-column
							type="selection"
							width="55">
					</el-table-column> -->

					<el-table-column
							prop="fingerNum"
							label="指纹编号"
							show-overflow-tooltip
							width="120">
					</el-table-column>

					<el-table-column
							prop="remark"
							label="说明"
							show-overflow-tooltip>
					</el-table-column>
					
					<el-table-column
							prop="createTime"
							label="采集时间"
							show-overflow-tooltip
							width="200">
					</el-table-column>

					<el-table-column
							prop="userName"
							label="采集人"
							show-overflow-tooltip
							width="140">
					</el-table-column>

					<el-table-column
							prop="icon"
							label="操作"
							width="120">

						<template slot-scope="scope">

							<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
							
							<el-divider direction="vertical"></el-divider>

								<template>
								<el-popconfirm title="确定删除该指纹信息吗？" @confirm="delHandle(scope.row.id)">
									<el-button type="text" slot="reference">删除</el-button>
								</el-popconfirm>
							</template>

						</template>
					</el-table-column>

				</el-table>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	export default {
		name: "Finger",
		data() {
			return {
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				editForm: {},

				fingerData: [],

				//采集指纹的人员信息
				collectPersonInfo: '',

				editFormRules: {
					fingerNum: [
						{required: true, message: '请选择指纹编号', trigger: 'blur'}
					]
				},

				multipleSelection: [],
				
				fingerNoOptions: [{
					value: '1',
					label: '第1个指纹'
					}, {
					value: '2',
					label: '第2个指纹'
					}, {
					value: '3',
					label: '第3个指纹'
					}],
				// 采集指纹提示信息
				collectTitle: '',
				isCollect: false,
				timer: "",
				timerValue: 30,
				// 指纹WebSocket对象
				fingerWs: null,
				// 指纹WebSocket地址
				fingerUrl: 'ws://localhost:9618',
				// 指纹特征值
				fingerVal: '',
				// 指纹采集状态标志，0-初始；1-检测设备成功
				fingerStatusFlag: 0,
				//指纹采集序号
				fingerIndex: 1,
				//检测手指
				checkFinger: false,
				//允许采集指纹特征值
				allowGetFinger: false,
				//成功获取指纹序号
				getFingerFlag: 0,
			}
		},
		//采集指纹的人员Id
		props: ["collectPersonId"],
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 430: 350
			}
		},
		created() {
			this.editForm.fingerNum = this.fingerNoOptions[0].value
		},
		beforeDestroy() {
			clearInterval(this.timer);
			// 销毁监听
			this.fingerWs.close
		},
		mounted() {
			this.$nextTick(function() {
				this.$on('getPersonFingerList', function() {
					this.$axios.get("/base/finger/list", {
						params: {
							personId: this.collectPersonId,
						}
					}).then(res => {
						this.fingerData = res.data.data.records
					})
				});
			});
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},
			handleSelectChange() {
				this.$forceUpdate()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.editForm = {}
			},
			getFingerList() {
				this.editForm.personId=this.collectPersonId
				this.$axios.get("/base/finger/list", {
					params: {
						personId: this.collectPersonId,
					}
				}).then(res => {
					this.fingerData = res.data.data.records
				})
			},
			startCollectFinger() {
				// 开始采集指纹
				this.timerValue=30;
				this.fingerVal='';
				this.isCollect=true;
				this.fingerStatusFlag=0;
				this.fingerIndex=1;
				this.checkFinger=false;
				this.allowGetFinger=false;
				this.getFingerFlag=0;
				//连接指纹采集设备
				this.ws_init();
				//检测指纹采集设备
				//this.ws_send({"reqcode":"FM_Init"});
				this.collectTitle='请把手指按压到指纹采集设备上';
				// 注意: 第一个参数为方法名的时候不要加括号;
				this.timer = setInterval(this.collectFinger, 1000); 
			},
			stopCollectFinger() {
				// 停止采集指纹
				this.isCollect=false;
				this.fingerStatusFlag=0;
				this.fingerIndex=1;
				//关闭指纹采集设备
				this.ws_send({"reqcode":"FM_Deinit"});
				this.collectTitle='';
				
				clearInterval(this.timer);
			},
			sendMsgToWs() {
				//检测指纹采集设备
				this.ws_send({"reqcode":"FM_Init"});
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/base/finger/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.collectTitle=''
										this.getFingerList()
									}
								});

								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.resetForm('editForm')
				this.$axios.get('/base/finger/info/' + id).then(res => {
					this.editForm = res.data.data
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/base/finger/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getFingerList()
						}
					});
				})
			},
			collectFinger(){
				
				if (this.fingerStatusFlag == 0) {
					//检测指纹采集设备
					this.ws_send({"reqcode":"FM_Init"});
					return;
				} else {
					if (this.getFingerFlag < 3) {
						//还没采集够3次
						if (this.checkFinger == false) {
							//检测手指
							this.ws_send({"reqcode":"FM_DetectFinger"});
						} else {
							if (this.allowGetFinger) {
								//获取手指特征值
								this.ws_send({"reqcode":"FM_Extract","index":this.fingerIndex});
							}
						}
					} else {
						//采集够3次后，合成指纹模板
						this.ws_send({"reqcode":"FM_Enroll"});
					}
				}

				if (this.timerValue > 0) {
					this.timerValue=this.timerValue-1;
				} else {
					this.stopCollectFinger();
				}
				
			},
			ws_init() {
				if(typeof(WebSocket) === "undefined"){
					alert("您的浏览器不支持socket")
				}else{
					if (this.fingerWs != null) {
						return;
					}
					// 实例化socket
					this.fingerWs = new WebSocket(this.fingerUrl)
					// 监听socket连接
					this.fingerWs.onopen = this.ws_open
					// 监听socket错误信息
					this.fingerWs.onerror = this.ws_error
					// 监听socket消息
					this.fingerWs.onmessage = this.ws_getMessage
					// 监听socket关闭
					this.fingerWs.onclose = this.ws_close
				}
			},
			ws_open() {
				console.log("WebSocket连接成功")
			},
			ws_error() {
				console.log("WebSocket连接错误")
			},
			ws_getMessage(msg) {
				var	s = msg.data.toString();
            	var obj = JSON.parse(s);
				console.log("WebSocket收到" + s)

				// 处理返回的结果标志
				this.handleWsResult(obj.result);

				if (obj.repcode === 'FM_Deinit') {
					return;
				}

				if (obj.repcode === 'FM_Init' && obj.result === '0') {
					//检测设备
					this.fingerStatusFlag=1;
					return;
				}

				if (this.fingerStatusFlag == 0) {
					//如果通信失败，则停止采集
					this.stopCollectFinger();
					return;
				}

				if (obj.repcode === 'FM_DetectFinger') {
					//检测手指
				   if (obj.result === '1') {
						//检测手指成功
						if (this.getFingerFlag < this.fingerIndex) {
							this.checkFinger=true;
							this.allowGetFinger=true;
						} else {
							this.checkFinger=false;
							this.allowGetFinger=false;
						}
						
					} else {
						//检测手指失败
						this.fingerIndex=this.getFingerFlag+1;
					}
					return;
				}

				if (obj.repcode === 'FM_Extract' && obj.result === '0') {
					//采集指纹特征值成功
					this.getFingerFlag=this.getFingerFlag+1;
					this.checkFinger=false;
					this.allowGetFinger=false;
					if (this.getFingerFlag < 3) {
						this.collectTitle='第[ '+ this.getFingerFlag + ']次指纹采集成功，请拿开手指再放手指';
					} else {
						this.collectTitle='第[ '+ this.getFingerFlag + ']次指纹采集成功，请稍等......';
					}
					
					return;
				}

				if (obj.repcode === 'FM_Enroll' && obj.result === '0') {
					//合成指纹模板成功
					// this.fingerVal=obj.template;
					this.editForm.fingerVal=obj.template;
					//停止采集指纹
					this.stopCollectFinger();
					this.collectTitle='指纹录入成功，请按【保存指纹】按钮保存';
				}
			},
			ws_send(params) {
				this.fingerWs.send(JSON.stringify(params))
			},
			ws_close() {
				console.log("WebSocket已经关闭")
			},

			handleWsResult(iret){
				if(iret === '-1')
				{
					this.collectTitle='参数错误';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-2')
				{
					this.collectTitle='内存分配失败，没有分配到足够的内存';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-3')
				{
					this.collectTitle='功能未实现';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-4')
				{
					this.collectTitle='设备不存在';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-7')
				{
					//this.collectTitle='提取特征失败或合成模板失败';
				}
				else if(iret === '-5')
				{
					this.collectTitle='设备未初始化';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-6')
				{
					this.collectTitle='非法错误号';
					this.fingerStatusFlag=0;
				}
				else if(iret === '-9')
				{
					this.collectTitle='其它错误';
					this.fingerStatusFlag=0;
				}
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 96%;
	}
</style>